/**
 * nn-oos-sort.js
 * Nashua Nutrition — OOS sink for the main collection grid.
 *
 * On DOMContentLoaded and after every eurus:collection:reloaded (AJAX sort/filter),
 * moves every sold-out .grid-item to the end of #items-grid, preserving relative
 * order of in-stock items and of OOS items (stable). Detects sold-out via
 * data-available="false" on the .grid-item wrapper (set by Liquid in
 * sections/main-collection-product-grid.liquid).
 *
 * Idempotent: re-running does not duplicate or scramble items.
 * Defensive: silently exits when the container is absent (non-collection pages).
 */

(function () {
  'use strict';

  function sinkOosItems() {
    var grid = document.getElementById('items-grid');
    if (!grid) return;

    var items = grid.querySelectorAll(':scope > .grid-item');
    if (!items.length) return;

    var inStock = [];
    var outOfStock = [];

    items.forEach(function (item) {
      if (item.dataset.available === 'false') {
        outOfStock.push(item);
      } else {
        inStock.push(item);
      }
    });

    // Only touch the DOM if there are OOS items to move.
    if (!outOfStock.length) return;

    // Check whether the order is already correct to keep this idempotent on
    // repeated calls (e.g., rapid filter changes) without unnecessary reflows.
    var lastInStock = null;
    var orderCorrect = true;
    items.forEach(function (item) {
      if (item.dataset.available !== 'false') {
        if (lastInStock && outOfStock.indexOf(lastInStock) !== -1) {
          // An in-stock item comes after an OOS item — order is wrong.
          orderCorrect = false;
        }
        lastInStock = item;
      }
    });

    // Simpler idempotency: re-build expected order and compare to current.
    var expected = inStock.concat(outOfStock);
    var current = Array.prototype.slice.call(items);
    var alreadySorted = expected.every(function (el, i) {
      return el === current[i];
    });
    if (alreadySorted) return;

    // Append in correct order. Using a DocumentFragment avoids multiple reflows.
    var frag = document.createDocumentFragment();
    expected.forEach(function (item) { frag.appendChild(item); });
    grid.appendChild(frag);
  }

  // Initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sinkOosItems);
  } else {
    sinkOosItems();
  }

  // After every AJAX sort/filter update by facets.js.
  document.addEventListener('eurus:collection:reloaded', sinkOosItems);
})();
